export default __webpack_public_path__ + "static/media/money.c7672de2.svg";